<template>
  <div id="hres85u">
    <hrms-search-box-table v-show="indexDisp"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres85uIndex"
            searchBoxAlias="approve"
            :detailEvent="detailEvent"
            :approveEvent="approveEvent"
            :approveRowBool="true" />

    <detail v-show="detailDisp"
            :labels="labels[dash.nowLang]"
            :labelsButton="dash.button[dash.nowLang]"
            :detail="detail"
            :codempid="codempid"            
            :toggle="toggle"
            :nowLang="dash.nowLang" 
            :tab2Table="columns[dash.nowLang].detailTab2" />

    <div class="form-group-button" v-show="false">
      <button class="btn bg-blue" data-toggle="modal" ref="approve" data-target="#hres85u-popup-approve"><i class="fa fa-list-alt"></i> {{ btn_approve }}</button>
    </div>

    <popup-approve :labels="labels[dash.nowLang]"
            :nowLang="dash.nowLang"
            :labelsButton="dash.button[dash.nowLang]"
            :indexSelected="indexSelected"
            :arrCodpay="dropdowns.codpay"
            :arrNumperiod="arrNumperiod"
            :codappr="codempid"
            :detailSubmit="detailSubmit"
            :descCodappr="dash.currentUser.username[dash.nowLang]"
            :postHres85uSendApprove="postHres85uSendApprove" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres85u/mutation-types'
import detail from 'components/hres85u/detail'
import popupApprove from 'components/hres85u/popupApprove'
import moment from 'moment'
import swal from 'sweetalert'

export default {
  name: 'hres85u',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      btn_approve: 'Approve',
      arrNumperiod: {
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9'
      }
    }
  },
  created () {
    this.receivedHres85uColumnsLabels()
    this.receivedHres85uIndex()
    // this.receivedHres85uApprove()
    this.receivedHres85uDropdowns()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES85U_INDEX_DISP,
      detailDisp: types.GET_HRES85U_DETAIL_DISP,
      columns: types.GET_HRES85U_COLUMNS,
      labels: types.GET_HRES85U_LABELS,
      index: types.GET_HRES85U_INDEX,
      indexSelected: types.GET_HRES85U_INDEX_SELECTED,
      detail: types.GET_HRES85U_DETAIL,
      dropdowns: types.GET_HRES85U_DROPDOWNS,
      detailSubmit: types.GET_HRES85U_DETAIL_SUBMIT
    })
  },
  methods: {
    // pageDetail (event) {
    //   let searchParams = {
    //     p_codempid: this.indexSelected.codempid,
    //     p_dtereq: this.indexSelected.dtereq,
    //     p_numseq: this.indexSelected.numseq
    //   }
    //   this.receivedHres85uDetail(searchParams)
    //   this.toggle('detail')
    // },

    pageDetail (event) {
      let detailParams = this.indexSelected
      this.receivedHres85uDetail(detailParams)
      this.toggle('detail')
    },

    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail()
    },
    approveEvent (dataRows) {
      let dataRowsFiltered = dataRows.filter(function (dataRow) {
        return dataRow.flgStaappr !== 'undefined' && dataRow.flgStaappr !== 'P' && dataRow.flgStaappr.trim() !== ''
      })
      if (dataRowsFiltered.length > 0) {
        this.setIndexSelected(dataRowsFiltered[0])
        this.receivedHres85uDetailSubmit(this.indexSelected)
        this.$refs.approve.click()
      } else {
        swal({
          title: 'ยืนยันการทำรายการ',
          text: 'รายการยังไม่ถูกเลือก'
        })
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES85U_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES85U_PAGE,
      receivedHres85uColumnsLabels: types.RECEIVED_HRES85U_COLUMNS_LABELS,
      receivedHres85uIndex: types.RECEIVED_HRES85U_INDEX,
      receivedHres85uDetail: types.RECEIVED_HRES85U_DETAIL,
      receivedHres85uDetailSubmit: types.RECEIVED_HRES85U_DETAIL_SUBMIT,
      postHres85uSendApprove: types.POST_HRES85U_SEND_APPROVE,
      receivedHres85uDropdowns: types.RECEIVED_HRES85U_DROPDOWNS
    })
  },
  components: {
    detail,
    popupApprove
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?9464075a